import React, {FunctionComponent, useState} from "react";
import {ChallengeRegistrationData, RegistrationStatus} from "/src/domain/challenges/ChallengeRegistrationData";
import {ChallengeUser} from "/src/domain/challenges/ChallengeUser";
import {TeamRegistrationHeader} from "/src/ui/challengesRegistration/teamRegistration/TeamRegistrationHeader";
import { Button, Dialog, DialogTitle, DialogActions } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import cs from "classnames"
import {useTranslation, Trans} from "react-i18next";
import { links } from "/src/domain/shared/links";

export type RegistrationStatusHeaderProps = {
    challengeData: ChallengeRegistrationData,
    currentUser: ChallengeUser
}

export const RegistrationStatusHeader: FunctionComponent<RegistrationStatusHeaderProps> = ({
                                                                                               challengeData,
                                                                                               currentUser
                                                                                           }) => {
    const classes = useStyles();
    const {t} = useTranslation();
    const [openNextDialog, setOpenNextDialog] = useState<boolean>(Boolean(challengeData.withStartNumber && !challengeData.startNumberUrl))
    

    if (!currentUser.challengeRegistration.isRegistered) {
        return (
            <>
                {challengeData.teamRegistration && <TeamRegistrationHeader/>}
                <div className={classes.subtitleWrapper}><h4 className={classes.yourData}>{t('yourData')}</h4>
                    <span className={classes.stravaId}>{`${t('Profile ID')}: ${currentUser.stravaId}`}</span></div>
            </>
        );
    }

    if (!challengeData.isPaid) {
        return <>
            <h3 className={cs(classes.header, {[classes.headerWithDescr]: !!challengeData.startNumberUrl})}>{t("registerSuccess")} {!!(challengeData.withStartNumber && !challengeData.startNumberUrl) && <Button variant="contained" href={links.origin}>
                { t('next') }
            </Button>}</h3>
            {!!challengeData.startNumberUrl && <StartNumberView startNumberUrl={challengeData.startNumberUrl}/>}
            <NextDialog open={openNextDialog} setOpen={setOpenNextDialog}/>
        </>;
    }

    if (challengeData.payment?.status == RegistrationStatus.NEW) {
        return (
            <h3 className={classes.header}>{t('registerSuccessUnpaid')}</h3>
        );
    }

    return <>
        <h3 className={cs(classes.header, {[classes.headerWithDescr]: !!challengeData.startNumberUrl})}>{t('registerSuccessPaid')} {!!(challengeData.withStartNumber && !challengeData.startNumberUrl) && <Button variant="contained" href={links.origin}>
            { t('next') }
        </Button>}</h3>
        {!!challengeData.startNumberUrl && <StartNumberView startNumberUrl={challengeData.startNumberUrl}/>}
        <NextDialog open={openNextDialog} setOpen={setOpenNextDialog}/>
    </>
};

interface NextDialogProps {
    open: boolean;
    setOpen: React.Dispatch<React.SetStateAction<boolean>>
}

const NextDialog: FunctionComponent<NextDialogProps> = ({ 
    open,
    setOpen,
}) => {
    const {t} = useTranslation();

    const handleClose = () => {
        setOpen(false);
    }

    return <Dialog
        open={open}
        onClose={handleClose}

      >
        <DialogTitle id="alert-dialog-title">
          { t('raceDescriptionDialog') }
        </DialogTitle>
        <DialogActions>
          <Button fullWidth variant="contained" href={links.origin} autoFocus>
            { t('here') }
          </Button>
        </DialogActions>
      </Dialog>
}

interface StartNumberViewProps {
  startNumberUrl: string;
}

const StartNumberView: FunctionComponent<StartNumberViewProps> = ({
  startNumberUrl,
}) => {
  const classes = useStyles();
  const { t } = useTranslation();

  return <>
    <p className={classes.startNumberDescription}>
        <Trans
            i18nKey="startNumberDescription"
            components={{
              b: <b />,
              i: <i />,
            }}
        />
    </p>
    <img className={classes.img} src={startNumberUrl} />
  </>;
};

const useStyles = makeStyles({
    yourData: {
        margin: "1rem 1.5rem",
        fontSize: "0.9rem",
        fontWeight: 500,
        display: "inline-block",
        whiteSpace: "nowrap"
    },
    subtitleWrapper: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        paddingRight: "1.5rem"
    },
    stravaId: {
        textAlign: "right"
    },
    header: {
        fontSize: "1.5rem",
        margin: "2.5rem 1.5rem"
    },
    headerWithDescr: {
        marginBottom: 0
    },
    img: {
        maxWidth: "95%",
        margin: "2.5rem 2.5% 1rem"
    },
    startNumberDescription: {
        fontSize: "1.5rem",
        whiteSpace: "pre-line",
        margin: "0 1.5rem",
    }
});